<template>
    <div class="main">
        <MyHeader index="4"></MyHeader>
        <div class="titleIfo">
            
            <div class="container" v-if=" this.$i18n.locale == 'zh_CN'">
                <h2>资源</h2>
                <h3>Resources</h3>
            </div>
            <div class="container" v-if=" this.$i18n.locale == 'en_US'">
                <h2>Resources</h2>
                <h3>资源</h3>
            </div>
        </div>
        
       
        <div class="newsInfo">
            <div class="container">
            
            
             <nav aria-label="Breadcrumb" class="breadcrumb2">
			  <ul>
				<li><a href="/">{{ $t("header.home") }}</a></li>
				<li><span style="margin-bottom:10px;"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 2 16 16">
  <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
</svg></span></li>
				<li><span aria-current="page">{{ $t("header.resources") }}</span></li>
			  </ul>
			</nav>
		
                <div class="content">
                    <div class="leftMenu" id="menu">
                        <ul>
                           
                           
                        
                        
                            <li :class="{'on':page.category_id == 76}" :cid="76">
                                <i>{{$t('Level.International level')}}</i>
                                <b></b>
                            </li>
                             <li :class="{'on':page.category_id == 77}" :cid="77">
                                <i>{{$t('Level.National level')}}</i>
                                <b></b>
                            </li>
                            <li :class="{'on':page.category_id == 78}" :cid="78">
                                <i>{{$t('Level.Local level')}}</i>
                                <b></b>
                            </li>
                        </ul>
                    </div>
                    <div class="rightContent">
                           <ul  v-if=" this.$i18n.locale == 'zh_CN'">
                                <li v-for="(item,i) in newsList">
                                   
                                     <router-link :to="{name:'resource',params:{id:item.id}}">
                                        <div class="newsImg">
                                            <img :src="item.thumb_image" alt="newsImg">
                                        </div>
                                        <div class="newText">
                                            <h3 >{{item.name}}</h3>                                
    	                                    <p >{{item.brief}}</p>
                                            <h6>{{$t('label.release')}}{{item.release_time}}</h6>
                                            
                                        </div>
                                    </router-link>
                                </li>
                            </ul>
                            
                             <ul  v-if=" this.$i18n.locale == 'en_US'">
                                <li v-for="(item,i) in newsList">
                                     <router-link :to="{name:'resource',params:{id:item.id}}">
                                        <div class="newsImg">
                                            <img :src="item.thumb_image" alt="newsImg">
                                        </div>
                                        <div class="newText">
                                            <h3 >{{item.name_en}}</h3>
                                            <p >{{item.brief_en}}</p>
                                             <h6>{{$t('label.release')}}{{item.release_time}}</h6>
                                            
                                        </div>
                                    </router-link>
                                </li>
                            </ul>
                            
                        <pagination :pageInfo="pageInfo" @change="pagechange"></pagination>
                    </div>
                </div>
            </div>
        </div>
        <MyFooter></MyFooter>
    </div>
</template>

<script>
    import MyHeader from './common/MyHeader'
    import MyFooter from './common/MyFooter'
    import pagination from './common/vue-pagination'
    import filter from '../filter.js';
    import {createArticle, getArticleList, getArticleDetails, deleteArticle, putArticle} from '@/services/article';
    import Breadcrumb from './common/Breadcrumb.vue'


    export default {
        name: "NewsPage",
        components: { MyHeader,MyFooter,pagination,Breadcrumb},
        data(){
            return{
                newsList : [],
                newsList1 : [],
                newsList2 : [],
                page:{
                    page_size:5,
                    page:1,
                    category_id:76,
                    
                },
                pageInfo:{
                    total:1,        // 记录总条数   默认空，如果小于pageNum则组件不显示   类型Number
                    current:1,      // 当前页数，   默认为1                             类型Number
                    pagenum:5,      // 每页显示条数,默认10                              类型Number
                    pagegroup:3,    // 分页条数     默认为5，需传入奇数                  类型Number
                    skin:'#13AE67'  // 选中页码的颜色主题 默认为'#16a086'                类型String
                }

            }
        },
       
  computed: {
    routes() {
      const routes = []
      let route = this.$route
      while (route) {
        routes.unshift(route)
        route = route.parent
      }
      return routes
    }
  },
        watch:{
		  $route(to,from){
			this.page.category_id = this.$route.params.id;
			
            this.getList();
		  }
		},
        mounted(){
        	this.page.category_id = this.$route.params.id;
            this.getList();
            this.menuClick();
            
            // 记录 referer
           //  let referer = localStorage.getItem("referer");
//             if (referer == "news_detail") {
//             	let category = localStorage.getItem("category");
//             	this.page.category_id = category;
//             	
//             	localStorage.setItem("referer","news");
//             }
        },
        methods:{
            getList(){
                
                getArticleList(this.page).then(res => {
                    let list = res.items;
                   
						for(var i in list){
							let item = list[i];
							item.release_time = filter.dateFormat(item.release_time,'yyyy-mm-dd');
						}
                        this.newsList = list;
                   
                    
                    this.pageInfo.total= res._meta.totalCount;
                    this.pageInfo.current= res._meta.currentPage;
                    this.pageInfo.pagenum= res._meta.perPage;
                   
                }).catch(err => {});
            },
            pagechange(current){
                this.page.page = current;
                this.getList();
            },
            menuClick(){
                let that = this;
                $('#menu li').on('click',function () {
                	var cid = $(this).attr("cid");
                	that.$router.push('/resources/'+cid)
                	
                   //  that.page.page = 1;
//                     $(this).addClass('on').siblings().removeClass('on');
//                     let index = Number($(this).index());
//                     that.page.category_id = that.categoryId(index);
//                     that.getList(function () {
//                         that.pageInfo.current = 1;
//                     });
                })
            },
           
            categoryId(id){
                let categoryId = 0;
                switch (id) {
                    case 0 : categoryId = 76; break;
                    case 1 : categoryId = 77; break;
                    case 2 : categoryId = 78; break;
                    default: categoryId = null; break;
                }
                return categoryId;
            }
        }
    }
</script>

<style lang="scss" scoped>


    .main {
        .titleIfo {
            width: 100%;
            height: 380px;
            background: url("./image/resources.jpg") no-repeat center center;
            background-size: cover;

            .container {
                h2 {
                    padding-top: 180px;
                    text-align: center;
                    color: #FFFFFF;
                    height: 42px;
                    font-size: 32px;
                    font-weight: bold;
                    line-height: 42px;
                }

                h3 {
                    text-align: center;
                    height: 29px;
                    font-size: 22px;
                    line-height: 29px;
                    color: #FFFFFF;
                }
            }
        }
        .newsInfo{
            .container {
                border-top: 1px solid #E6E6E6;
                .content {
                    margin-top: 30px;
                    overflow: hidden;
                    margin-bottom: 48px;
                    .leftMenu {
                        width: 246px;
                        float: left;
                        ul {
                            li {
                                cursor: pointer;
                                padding: 0 16px;
                                border-radius: 18px;
                                height: 36px;
                                overflow: hidden;
                                line-height: 36px;
                                margin-bottom: 10px;

                                &:last-child {
                                    margin-bottom: 0;
                                }

                                i {
                                    display: inline-block;
                                    float: left;
                                    color: #252525;
                                    font-size: 16px;
                                }

                                b {
                                    display: inline-block;
                                    float: right;
                                    width: 30px;
                                    height: 100%;
                                    background: url("./image/yy2.png") no-repeat center center;
                                    background-size: 100%;
                                    line-height: 36px;
                                }

                            }

                            .on {
                                background: #13AE67;

                                i {
                                    color: #FFFFFF;
                                }

                                b {
                                    background: url("./image/yy.png") no-repeat center center;
                                    background-size: 86%;
                                }
                            }
                        }
                    }
                    .rightContent{
                        float: right;
                        ul{
                            li{
                                margin-bottom: 40px;
                                &:last-child{
                                    margin-bottom: 32px;
                                }
                                a{
                                    overflow: hidden;
                                    display: block;
                                    .newsImg{
                                        float: left;
                                        width: 216px;
                                        height: 144px;
                                        img{
                                            width: 100%;
                                        }
                                    }
                                    .newText{
                                        float: left;
                                        margin-left: 20px;
                                        width: 584px;
                                        h3{
                                            margin-top: 7px;
                                            color: #252525;
                                            height:24px;
                                            font-size:18px;
                                            font-weight:bold;
                                            line-height:24px;
                                        }
                                        p{
                                            display: block;
                                            font-size: 14px;
                                            color: #505050;
                                            line-height: 20px;
                                            height: 60px;
                                            margin-top: 16px;
                                            display: -webkit-box;
                                            -webkit-box-orient: vertical;
                                            -webkit-line-clamp: 3;
                                            overflow: hidden;
                                        }
                                        h6{
                                            margin-top: 22px;
                                            height:12px;
                                            font-size:12px;
                                            color:#A0A0A0;
                                            line-height:12px;
                                        }
                                    }
                                }
                            }
                        }

                    }
                }
            }
        }
    }
</style>